import { render, staticRenderFns } from "./IbAgreementTab.vue?vue&type=template&id=fb13e3aa"
import script from "./IbAgreementTab.vue?vue&type=script&lang=js"
export * from "./IbAgreementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports